<ng-container *ngIf="showHeader">
    <img class="banner-img center-block div-print" src="https://gestionatupyme-public.s3.amazonaws.com/banner.png" alt=""/>
</ng-container>

<mat-card class="simple-card mx-auto mb-5">
  <mat-card-content>
    <div class="row">

        <div class="col-12 d-flex justify-content-between" *ngIf="!fromConsolidado && showHeader">
            <h1>Poder Judicial</h1>
            <div class="row">
                <div class="col-12 d-flex justify-content-end">
                    <button mat-flat-button 
                        class="custom-button-primary mb-2 no-print"
                        (click)="descargarPDF()"
                    >
                        <mat-icon 
                            aria-hidden="false" 
                            aria-label="Icono de descarga" 
                            fontIcon="get_app" 
                            class="icon-download mr-3"
                        ></mat-icon>
                        Descargar Resultado
                    </button>
                </div>
                <div class="col-12 d-flex justify-content-end" *ngIf="fromModule">
                    <span class="font-italic">Al descargar se imprimiran 24 causas de cada tipo*</span>
                </div>
            </div>
        </div>

        <div class="col-12" *ngIf="fromConsolidado && showHeader">
            <h1>Poder Judicial</h1>
        </div>

        <div class="col-12 my-3" *ngIf="showHeader">
            <mat-chip-set aria-label="Rut principal">
                <mat-chip class="chip-rut"><strong>RUT:</strong> {{content.poderJudicialReporte.datosBasicosSolicitud.Rut |
                    uppercase | number : '1.0-0'}}-{{content.poderJudicialReporte.datosBasicosSolicitud.DV | uppercase}}</mat-chip>
            </mat-chip-set>
        </div>

        <div class="col-12 my-3 text-center">
            <div class="table-responsive border-0">
                <mat-button-toggle-group name="tiposCausas" aria-label="Tipos Causas" [(ngModel)]="contentShow">
                    <mat-button-toggle value="civiles" (click)='selectedCivilIndex = 0; resetPagination()' class="mat-button-toggle-custom">
                        <mat-icon 
                            *ngIf="contentShow == 'civiles'"
                            aria-hidden="false" 
                            aria-label="Icono de seleccion" 
                            fontIcon="check" 
                            class="icon-download mt-2 mr-2 no-print"
                        ></mat-icon>
                        Civiles
                        <mat-chip class="mx-2" [ngClass]="totalCivil > 0 ? 'chip-causa-error' : 'chip-causa-tertiary'">
                            <span class="span-total">{{totalCivil}}</span>
                        </mat-chip>
                    </mat-button-toggle>
                    <mat-button-toggle value="laboral" (click)='selectedLaboralIndex = 0; resetPagination()' class="mat-button-toggle-custom">
                        <mat-icon 
                            *ngIf="contentShow == 'laboral'"
                            aria-hidden="false" 
                            aria-label="Icono de seleccion" 
                            fontIcon="check" 
                            class="icon-download mt-2 mr-2 no-print"
                        ></mat-icon>
                        Laborales
                        <mat-chip class="mx-2" [ngClass]="totalLaboral > 0 ? 'chip-causa-error' : 'chip-causa-tertiary'">
                            <span class="span-total">{{totalLaboral}}</span>
                        </mat-chip>
                    </mat-button-toggle>
                    <mat-button-toggle value="cobranza" (click)='selectedCobranzaIndex = 0; resetPagination()' class="mat-button-toggle-custom">
                        <mat-icon 
                            *ngIf="contentShow == 'cobranza'"
                            aria-hidden="false" 
                            aria-label="Icono de seleccion" 
                            fontIcon="check" 
                            class="icon-download mt-2 mr-2 no-print"
                        ></mat-icon>
                        Cobranza Laboral
                        <mat-chip class="mx-2" [ngClass]="totalCobranza > 0 ? 'chip-causa-error' : 'chip-causa-tertiary'">
                            <span class="span-total">{{totalCobranza}}</span>
                        </mat-chip>
                    </mat-button-toggle>
                    <mat-button-toggle value="tributario" class="mat-button-toggle-custom">
                        <mat-icon 
                            *ngIf="contentShow == 'tributario'"
                            aria-hidden="false" 
                            aria-label="Icono de seleccion" 
                            fontIcon="check" 
                            class="icon-download mt-2 mr-2 no-print"
                        ></mat-icon>
                        Tributario
                        <mat-chip class="mx-2" [ngClass]="totalTributario > 0 ? 'chip-causa-error' : 'chip-causa-tertiary'">
                            <span class="span-total">{{totalTributario}}</span>
                        </mat-chip>
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </div>

        <div class="col-12 mt-3 mx-auto">
            <div class="row">
                <div class="col-sm-12 col-md-7 col-lg-8">
                    <div class="info-span-error py-2 px-3">
                        <p class="text-center text-wrap my-1">
                            Para conocer si hay actualizaciones a las causas informadas deberá ir al link donde podrá consultar directamente en el poder judicial la posible actualización 
                        </p>
                    </div>
                </div>
    
                <div class="col-sm-12 col-md-5 col-lg-4 no-print">
                    <button mat-flat-button 
                        class="custom-button-secondary mr-2 mb-2 no-print float-right"
                        (click)="redireccion()"
                    >
                        <mat-icon 
                            aria-hidden="false" 
                            aria-label="Icono de redireccion" 
                            fontIcon="navigate_next" 
                            class="icon-download mb-2 mr-3"
                        ></mat-icon>
                        Revisar en Poder Judicial
                    </button>
                </div>
            </div>
        </div>

        <div class="col-12 mt-3 no-print" *ngIf="fechaExtraccion">
            <mat-chip class="chip-fecha float-right"><strong>Fecha extracción:</strong> {{fechaExtraccion | date: 'dd-MM-YYYY' }}</mat-chip>
        </div>

        <div class="col-12 mt-3" *ngIf="fromFlujoDeCredito">
            <span class="font-italic">Solo se muestra un máximo de 24 causas por tipo*</span>
        </div>

        <div class="col-12 mt-3" *ngIf="hasCivil" [ngClass]="[contentShow === 'civiles'? 'showContent in active': 'div-print']">
            <mat-card>
                <mat-card-header>
                    <mat-card-title class="font-size-title-card">
                        <mat-chip class="chip-info mr-3"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                        <strong>Civiles</strong>
                        <p class="d-inline fecha_size ml-2" *ngIf="fromConsolidado">({{content.poderJudicialReporte?.datosBasicosSolicitud?.FechaReporte | date: 'dd-MM-yyyy'}})</p>
                    </mat-card-title>
                </mat-card-header>
            
                <mat-card-content>
        
                    <div class="row p-5 full-size-print">
                        <div class="col-12 border mx-auto px-0">
                            <div class="table-responsive">
                                <table mat-table [dataSource]="content?.poderJudicialReporte?.poderJudicial?.Civil || []" class="tabla-detalles">
                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef></th>
                                        <td mat-cell *matCellDef="let element; let i = index;" class="align-middle">
                                            <mat-icon 
                                                aria-hidden="false" 
                                                aria-label="Icono de buscar" 
                                                fontIcon="search" 
                                                class="primary-seach-icon-text mx-auto cursor-pointer no-print"
                                                (click)="selectCivilCase(element.id, 'civil_'+element.id+'_'+i); selectedCivilIndex = 0"
                                            ></mat-icon>    
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="rol">
                                        <th mat-header-cell *matHeaderCellDef> Rol </th>
                                        <td mat-cell *matCellDef="let element"> {{element?.rol || element?.details?.['ROL:']}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="fecha">
                                        <th mat-header-cell *matHeaderCellDef> Fecha </th>
                                        <td mat-cell *matCellDef="let element"> {{element.fecha}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="caratulado">
                                        <th mat-header-cell *matHeaderCellDef> Caratulado </th>
                                        <td mat-cell *matCellDef="let element"> {{element.caratulado}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="tribunal">
                                        <th mat-header-cell *matHeaderCellDef> Tribunal </th>
                                        <td mat-cell *matCellDef="let element"> {{element.tribunal}} </td>
                                    </ng-container>
    
                                    <tr mat-header-row *matHeaderRowDef="displayedColumnsCausasCiviles"></tr>
                                    <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumnsCausasCiviles;" [ngClass]="{'highlighted-row': highlightedRowId === 'row-civil_' + row.id + '_' + i}" [attr.id]="'row-civil_' + row.id + '_' + i"></tr>
                                </table>
                            </div>
                        </div>
                        <div class="col-12 mt-3" *ngIf="paginated">
                            <ng-container *ngTemplateOutlet="paginatorTemplate"></ng-container>
                        </div>
                    </div>
        
                </mat-card-content>
            </mat-card>
        </div>

        <div class="col-12 mt-3" *ngIf="hasLaboral" [ngClass]="[contentShow === 'laboral'? 'showContent in active': 'div-print']">
            <mat-card>
                <mat-card-header>
                    <mat-card-title class="font-size-title-card">
                        <mat-chip class="chip-info mr-3"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                        <strong>Laborales</strong>
                        <p class="d-inline fecha_size ml-2" *ngIf="fromConsolidado">({{content.poderJudicialReporte?.datosBasicosSolicitud?.FechaReporte | date: 'dd-MM-yyyy'}})</p>
                    </mat-card-title>
                </mat-card-header>
            
                <mat-card-content>
        
                    <div class="row p-5 full-size-print">
                        <div class="col-12 border mx-auto px-0">
                            <div class="table-responsive">
                                <table mat-table [dataSource]="content?.poderJudicialReporte?.poderJudicial?.Laboral || []" class="tabla-detalles">
                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef></th>
                                        <td mat-cell *matCellDef="let element; let i = index;" class="align-middle">
                                            <mat-icon 
                                                aria-hidden="false" 
                                                aria-label="Icono de buscar" 
                                                fontIcon="search" 
                                                class="primary-seach-icon-text mx-auto cursor-pointer no-print"
                                                (click)="selectLaboralCase(element.id, 'laboral_'+element.id+'_'+i); selectedLaboralIndex = 0"
                                            ></mat-icon>    
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="rit">
                                        <th mat-header-cell *matHeaderCellDef> Rit </th>
                                        <td mat-cell *matCellDef="let element"> {{element?.rit || element?.details?.['RIT :']}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="tribunal">
                                        <th mat-header-cell *matHeaderCellDef> Tribunal </th>
                                        <td mat-cell *matCellDef="let element"> {{element.tribunal}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="caratulado">
                                        <th mat-header-cell *matHeaderCellDef> Caratulado </th>
                                        <td mat-cell *matCellDef="let element"> {{element.caratulado}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="fecha_ingreso">
                                        <th mat-header-cell *matHeaderCellDef> Fecha Ingreso </th>
                                        <td mat-cell *matCellDef="let element"> {{element?.["fecha ingreso"]}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="estado_causa">
                                        <th mat-header-cell *matHeaderCellDef> Estado Causa </th>
                                        <td mat-cell *matCellDef="let element"> {{element?.["estado causa"]}} </td>
                                    </ng-container>
    
                                    <tr mat-header-row *matHeaderRowDef="displayedColumnsCausasLaborales"></tr>
                                    <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumnsCausasLaborales;" [ngClass]="{'highlighted-row': highlightedRowId === 'row-laboral_' + row.id + '_' + i}" [attr.id]="'row-laboral_' + row.id + '_' + i"></tr>
                                </table>
                            </div>
                        </div>
                        <div class="col-12 mt-3" *ngIf="paginated">
                            <ng-container *ngTemplateOutlet="paginatorTemplate"></ng-container>
                        </div>
                    </div>
        
                </mat-card-content>
            </mat-card>
        </div>

        <div class="col-12 mt-3" *ngIf="hasCobranza" [ngClass]="[contentShow === 'cobranza'? 'showContent in active': 'div-print']">
            <mat-card>
                <mat-card-header>
                    <mat-card-title class="font-size-title-card">
                        <mat-chip class="chip-info mr-3"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                        <strong>Cobranza Laboral</strong>
                        <p class="d-inline fecha_size ml-2" *ngIf="fromConsolidado">({{content.poderJudicialReporte?.datosBasicosSolicitud?.FechaReporte | date: 'dd-MM-yyyy'}})</p>
                    </mat-card-title>
                </mat-card-header>
            
                <mat-card-content>
        
                    <div class="row p-5 full-size-print">
                        <div class="col-12 border mx-auto px-0">
                            <div class="table-responsive">
                                <table mat-table [dataSource]="content?.poderJudicialReporte?.poderJudicial?.Cobranza || []" class="tabla-detalles">
                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef></th>
                                        <td mat-cell *matCellDef="let element; let i = index;" class="align-middle">
                                            <mat-icon 
                                                aria-hidden="false" 
                                                aria-label="Icono de buscar" 
                                                fontIcon="search" 
                                                class="primary-seach-icon-text mx-auto cursor-pointer no-print"
                                                (click)="selectCobranzaCase(element.id, 'cobranza_'+element.id+'_'+i); selectedCobranzaIndex = 0"
                                            ></mat-icon>    
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="rit">
                                        <th mat-header-cell *matHeaderCellDef> Rit </th>
                                        <td mat-cell *matCellDef="let element"> {{element?.rit || element?.details?.['RIT :']}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="ruc">
                                        <th mat-header-cell *matHeaderCellDef> Ruc </th>
                                        <td mat-cell *matCellDef="let element"> {{element.ruc}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="tribunal">
                                        <th mat-header-cell *matHeaderCellDef> Tribunal </th>
                                        <td mat-cell *matCellDef="let element"> {{element.tribunal}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="caratulado">
                                        <th mat-header-cell *matHeaderCellDef> Caratulado </th>
                                        <td mat-cell *matCellDef="let element"> {{element.caratulado}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="fecha_ingreso">
                                        <th mat-header-cell *matHeaderCellDef> Fecha Ingreso </th>
                                        <td mat-cell *matCellDef="let element"> {{element?.["fecha ingreso"]}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="estado_causa">
                                        <th mat-header-cell *matHeaderCellDef> Estado Procesal </th>
                                        <td mat-cell *matCellDef="let element"> {{element?.["estado causa"]}} </td>
                                    </ng-container>
    
                                    <tr mat-header-row *matHeaderRowDef="displayedColumnsCausasCobranza"></tr>
                                    <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumnsCausasCobranza;" [ngClass]="{'highlighted-row': highlightedRowId === 'row-cobranza_' + row.id + '_' + i}" [attr.id]="'row-cobranza_' + row.id + '_' + i"></tr>
                                </table>
                            </div>
                        </div>
                        <div class="col-12 mt-3" *ngIf="paginated">
                            <ng-container *ngTemplateOutlet="paginatorTemplate"></ng-container>
                        </div>
                    </div>
        
                </mat-card-content>
            </mat-card>
        </div>

        <div class="col-12 mt-3 no-print" *ngIf="(civilCaseSelected && hasCivil && contentShow === 'civiles') || (laboralCaseSelected && hasLaboral && contentShow === 'laboral') || (cobranzaCaseSelected && hasCobranza && contentShow === 'cobranza')">
            <mat-card [id]="idDetalle">
                <mat-card-header>
                    <mat-card-title class="font-size-title-card">
                        <mat-chip class="chip-info mr-3"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                        <strong *ngIf="contentShow === 'civiles'">Detalle causa civil</strong>
                        <strong *ngIf="contentShow === 'laboral'">Detalle causa laboral</strong>
                        <strong *ngIf="contentShow === 'cobranza'">Detalle cobranza laboral</strong>
                    </mat-card-title>
                </mat-card-header>
            
                <mat-card-content>
                    <div class="row no-print">
                        <div class="col-sm-12 d-flex justify-content-end">
                            <button mat-stroked-button (click)="volverAlListado(idDetalle)">
                                <mat-icon>arrow_upward</mat-icon> Volver al listado
                            </button>
                        </div>
                    </div>

                    <div class="row p-5" *ngIf="detalleHeader && detalleHeader.length > 0">
                        <div class="col-sm-6 col-md-4 my-3 d-flex" *ngFor="let head of detalleHeader">
                            <div class="info-span p-3">
                                <div class="text-wrap m-0"><strong *ngIf="head.title">{{head.title}}</strong> {{head.value}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 mx-auto">
                            <mat-tab-group animationDuration="0ms" fitInkBarToContent class="mat-tab-group-custom">
                                <ng-container *ngFor="let buttonInfo of getTabsList(); let i = index">
                                    <mat-tab label="{{buttonInfo.title}}">
                                        <div class="row">
                                            <div class="col-12 mt-5 px-5">
                                                <div class="table-responsive">
                                                    <table mat-table [dataSource]="buttonInfo.content">
                                                        <ng-container [matColumnDef]="column" *ngFor="let column of buttonInfo.displayColumns; let indexButton = index">
                                                          <th mat-header-cell *matHeaderCellDef> {{buttonInfo.titleTable[indexButton]}} </th>
                                                          <td mat-cell *matCellDef="let element"> {{element[column]}} </td>
                                                        </ng-container>
                                                      
                                                        <tr mat-header-row *matHeaderRowDef="buttonInfo.displayColumns"></tr>
                                                        <tr mat-row *matRowDef="let row; columns: buttonInfo.displayColumns;"></tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </mat-tab>
                                </ng-container>
                            </mat-tab-group>
                        </div>
                    </div>

                </mat-card-content>
            </mat-card>
        </div>

        <div class="col-12 my-4 div-print">
            <div class="info-data-span p-3">
                <p class="text-center text-wrap">
                    La información presentada en estos análisis proviene de fuentes consideradas altamente confiables. Sin embargo, dada la posibilidad de error humano o mecánico, no
                    se garantiza la exactitud o integridad de la información y, por tanto, no se hace responsable de errores u omisiones, como tampoco de las consecuencias asociadas con
                    el empleo de esa información.
                </p>
            </div>
        </div>

    </div>
  </mat-card-content>
</mat-card>


<ng-template #paginatorTemplate>
    <mat-paginator 
        [pageSizeOptions]="paginationOptions"
        [length]="totalItems"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        showFirstLastButtons 
        aria-label="Seleccionar página"
        (page)="handlePageEvent($event)"
    >
    </mat-paginator>
</ng-template>